export const RAMS_EFFECTIVE_DATE_CLAUSE =
  `(EFFECTIVE_START_DATE IS NULL OR EFFECTIVE_START_DATE <= CURRENT_TIMESTAMP) AND (EFFECTIVE_END_DATE IS NULL OR EFFECTIVE_END_DATE > CURRENT_TIMESTAMP)`;
